import * as React from "react";
import * as Text from "@repo/ui/components/ui/text";

import { cn } from "@repo/common/utils/cn";

/**
 *
 * Card
 *
 */
const _cardBase = cn(
  "rounded-lg bg-background border border-border text-foreground shadow-sm p-6",
);
const _cardFlex = "flex flex-col gap-2";

function Card({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card"
      className={cn(_cardBase, _cardFlex, className)}
      {...props}
    />
  );
}

/**
 *
 * Card Header
 * -
 * For use with title + description
 *
 */
function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn("flex flex-col space-y-1", className)}
      {...props}
    />
  );
}

/**
 *
 * Card Title
 * -
 * Extends Text.Header
 *
 */
const CardTitle = ({ ...props }: Text.TextHeadingProps) => (
  <Text.Heading size="sm" {...props} />
);

/**
 *
 * Card Description
 * -
 * Extends Text.Body
 *
 */
const CardDescription = ({ ...props }: Text.TextBodyProps) => (
  <Text.Body className="text-gray-500" {...props} />
);

/**
 *
 * Card body
 *
 */
function CardBody({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-body"
      className={cn("space-y-1", className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("p-6 pt-0", className)}
      {...props}
    />
  );
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("flex items-center p-6 pt-0", className)}
      {...props}
    />
  );
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
  CardBody,
};
